module.exports = __webpack_public_path__ + "img/KinokoTable30.f7c12556.jpg";